import { render } from "./Rule.vue?vue&type=template&id=1e74e2b9&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=1e74e2b9&lang=less&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74e2b9"]])

export default __exports__